import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { IBusinessFunction } from "../../interfaces/ibusinessfunction";

@Component({
    selector: "termsofuse",
    templateUrl: "./termsofuse.component.html",
    standalone: false
})
export class TermsOfUseComponent implements OnInit {
    termsOfUse!: string;

    constructor(private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        const defaultRoute: string | null = this.activatedRoute.snapshot.paramMap.get("defaultroute");
        const businessFunctions = AuthService.businessFunctions;
        const businessFunction: IBusinessFunction | undefined = businessFunctions?.find(e => e.defaultRoute === `/${defaultRoute}`);
        if (businessFunction) {
            this.termsOfUse = businessFunction.disclaimers;
        } else {
            this.termsOfUse = "";
        }
    }
}